import { useEffect, useState } from "react";
import { Box, TextField, Typography } from "@mui/material";

const AdminServices = ({ artifacts, setArtifacts }) => {
  const [insurance, setInsurance] = useState();
  const [Knowledgehub, setKnowledgehub] = useState();
  const [prequal, setPrequal] = useState();
  const [license, setLicense] = useState();

  useEffect(() => {
    if (artifacts?.length > 0) {
      setInsurance(artifacts?.find((s) => s.service_id === 1));
      setKnowledgehub(artifacts?.find((s) => s.service_id === 2));
      setPrequal(artifacts?.find((s) => s.service_id === 4));
      setLicense(artifacts?.find((s) => s.service_id === 3));
    }
  }, [artifacts]);

  const handleTextChange = (field, serviceId, value) => {
    setArtifacts((prev) => {
      const existingService = prev.services.find(
        (item) => item.service_id === serviceId
      );

      const updatedServices = existingService
        ? prev.services.map((item) =>
            item.service_id === serviceId
              ? { ...item, [field]: value, isEdit: true }
              : item
          )
        : [
            ...prev.services,
            { service_id: serviceId, [field]: value, isEdit: true },
          ];

      return {
        ...prev,
        services: updatedServices,
      };
    });
  };

  // ✅ Check if any service is edited
  const isAnyServiceEdited = artifacts?.some((s) => s.isEdit);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        p: "6px",
        gap: 2,
        borderRadius: 2,
        bgcolor: isAnyServiceEdited ? "#FFF7F7" : null, // highlight like others
      }}
    >
      <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
        {/* English Column */}
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography fontSize={15} fontWeight="bold" color="gray">
            English
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            label={"Verify Insurance"}
            onChange={(e) =>
              handleTextChange("service_text", 1, e.target.value)
            }
            value={insurance?.service_text || ""}
            multiline
          />
        </Box>
        {/* Spanish Column */}
        <Box sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2 }}>
          <Typography fontSize={15} fontWeight="bold" color="gray">
            Spanish
          </Typography>
          <TextField
            fullWidth
            variant="outlined"
            label={"Verificar seguro"}
            onChange={(e) =>
              handleTextChange("es_service_text", 1, e.target.value)
            }
            value={insurance?.es_service_text || ""}
            multiline
          />
        </Box>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
        <TextField
          fullWidth
          variant="outlined"
          label={"Knowledge Hub"}
          onChange={(e) => handleTextChange("service_text", 2, e.target.value)}
          value={Knowledgehub?.service_text || ""}
          multiline
        />

        <TextField
          fullWidth
          variant="outlined"
          label={"Centro de conocimiento"}
          onChange={(e) =>
            handleTextChange("es_service_text", 2, e.target.value)
          }
          value={Knowledgehub?.es_service_text || ""}
          multiline
        />
      </Box>
      <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
        <TextField
          fullWidth
          variant="outlined"
          label={"Driver License"}
          onChange={(e) => handleTextChange("service_text", 3, e.target.value)}
          value={license?.service_text || ""}
          multiline
        />

        <TextField
          fullWidth
          variant="outlined"
          label={"Licencia de conducir"}
          onChange={(e) =>
            handleTextChange("es_service_text", 3, e.target.value)
          }
          value={license?.es_service_text || ""}
          multiline
        />
      </Box>
      <Box sx={{ display: "flex", flexDirection: "row", gap: 2 }}>
        <TextField
          fullWidth
          variant="outlined"
          label={"Pre-Qualification"}
          onChange={(e) => handleTextChange("service_text", 4, e.target.value)}
          value={prequal?.service_text || ""}
          multiline
        />

        <TextField
          fullWidth
          variant="outlined"
          label={"Precalificación"}
          onChange={(e) =>
            handleTextChange("es_service_text", 4, e.target.value)
          }
          value={prequal?.es_service_text || ""}
          multiline
        />
      </Box>
    </Box>
  );
};

export default AdminServices;



//  <Box
//           key={service.id}
//           sx={{
//             backgroundColor: isServiceEdited(service.id) ? "#FFF7F7" : null,
//             display: "flex",
//             flexDirection: "column",
//             width: "100%",
//           }}
//         >
//           <TextField
//             fullWidth
//             variant="outlined"
//             label={service.label}
//             v alue={getServiceText(service.id)}
//             multiline
//             onChange={(e) => handleTextChange(service.id, e.target.value)}
//           />
//         </Box>
